import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RequestExecutor} from '../util/request-executor';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import * as fs from 'file-saver';

@Component({
  selector: 'app-app-updates-component',
  templateUrl: './app-updates-component.component.html',
  standalone: true,
  styleUrl: './app-updates-component.component.css'
})
export class AppUpdatesComponentComponent implements OnInit {
  @ViewChild('content', {read: ElementRef})
  content: ElementRef;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private request: RequestExecutor) {
  }

  ngOnInit(): void {
    this.fetchContent();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.fetchContent();
      });
  }

  fetchContent() {
    let apk = this.activatedRoute.snapshot.queryParams['apk'];

    console.log(this.activatedRoute.snapshot);

    if (this.activatedRoute.snapshot.routeConfig.path.includes('appupdates')) {
      if (apk == null || apk.length == 0) {
        this.getAppUpdatesList();
      } else {
        this.getAppUpdateDetails(apk);
      }
    } else {
      this.downloadApk(apk)
    }
  }

  private getAppUpdatesList() {
    this.request.get('/appupdates', null, 'text')
      .then(response => {
        this.content.nativeElement.innerHTML = response.toString();
      });
  }

  private getAppUpdateDetails(apk: string) {
    this.request.get('/appupdates?apk=' + apk, null, 'text')
      .then(response => {
        this.content.nativeElement.innerHTML = response.toString();
      });
  }

  private downloadApk(apk: string) {
    this.request.get('/appupdate?apk=' + apk, null, 'blob')
      .then(response => {
        const blob = new Blob([response], {type: 'application/vnd.android.package-archive'});
        fs.saveAs(blob, apk);
      });
  }
}
